import React, { useEffect, useState } from "react";
import Axios from 'services/BackendApi/BackendApi';

export default function MessageRenderer(props){
    const {keyCode} = props;
    const [message,setMessage] = useState({loading:false, html:'',finalized:false});
    useEffect(()=>{
        //if (message.finalized==false){
            fetchMessage();
        //}
    },[]);
    async function fetchMessage(){
        if (message.loading==false && message.finalized==false){
            setMessage({loading:true,html:'',finalized:false});
            const {data} = await Axios.Msg({},{urlParams:{ key: keyCode}});
            //console.log(data);
            setMessage({loading:false,html:data.content,finalized:true});
        }else{
            console.log('Problem fetching key: '+keyCode);
        }
    }
    console.log('Render', keyCode);
    return <div className={"msg-"+keyCode + " state-"+((message.loading==true)?"loading":"done")} dangerouslySetInnerHTML={{__html: (message.finalized==true)?(message.html ):"..."}} >
    </div>; 
}